import { FormattedMessage } from 'react-intl';

import messages from './UnlinkAccountModal.messages';
import styles from './UnlinkAccountModal.module.css';
import ConfirmationButton from '../../../ui/confirmationButton/ConfirmationButton';
import { Prompt } from '../../../ui/prompt/index';

export const UnlinkAccountModal = ({
    unlinkingLinkedAccountName,
    accountUnlinkingInProgress,
    unlinkingLinkedAccountStatus,
    onConfirm,
    closeModal
}: {
    unlinkingLinkedAccountName: string | null;
    accountUnlinkingInProgress: boolean;
    unlinkingLinkedAccountStatus: 'success' | 'error' | null;
    onConfirm: () => void;
    closeModal: () => void;
}) => {
    return (
        <div
            data-testid="unlink-account-modal"
            className={styles.UnlinkAccountModal}
        >
            <h3>
                <FormattedMessage
                    {...messages.title}
                    values={{ bankName: unlinkingLinkedAccountName }}
                />
            </h3>
            <p>
                <FormattedMessage {...messages.subTitle} />
            </p>
            <Prompt>
                <button onClick={closeModal}>
                    <FormattedMessage {...messages.cancel} />
                </button>
                <ConfirmationButton
                    data-testid="confirm-unlink-account"
                    onClick={onConfirm}
                    loading={accountUnlinkingInProgress}
                    status={unlinkingLinkedAccountStatus}
                >
                    <FormattedMessage {...messages.unlink} />
                </ConfirmationButton>
            </Prompt>
        </div>
    );
};
